import { DataModel } from "../../base/DataModel.js";
import { ContainerEnvVariableList } from "./ContainerEnvVariable.js";
import { ContainerPortList } from "./ContainerPort.js";
import { ContainerVolumeRelationList } from "./ContainerVolumeRelation.js";
import type { ContainerStateData } from "./types.js";

export class ContainerState extends DataModel<ContainerStateData> {
  public readonly image: string;
  public readonly imageDigest?: string;
  public readonly envs?: ContainerEnvVariableList;
  public readonly volumes: ContainerVolumeRelationList;
  public readonly ports: ContainerPortList;

  public constructor(data: ContainerStateData) {
    super(data);
    this.image = data.image;
    this.imageDigest = data.imageDigest
      ? data.imageDigest.split(":")[1]
      : undefined;
    this.envs = data.envs ? new ContainerEnvVariableList(data.envs) : undefined;
    this.volumes = new ContainerVolumeRelationList(data.volumes ?? []);
    this.ports = new ContainerPortList(data.ports ?? []);
  }
}
